import { render, staticRenderFns } from "./VodReplay.vue?vue&type=template&id=6f477158&scoped=true&"
import script from "./VodReplay.vue?vue&type=script&lang=js&"
export * from "./VodReplay.vue?vue&type=script&lang=js&"
import style0 from "./VodReplay.vue?vue&type=style&index=0&id=6f477158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f477158",
  null
  
)

export default component.exports